interface IProps {
    top: number;
    left: number;
    zeroTop: number;
    zeroLeft: number;
    isPositionFixed?: boolean;
}

function getFloatingWrapperPosition({ isPositionFixed, top, left, zeroTop, zeroLeft }: IProps): {
    top: number;
    left: number;
} {
    if (isPositionFixed) {
        return { top, left };
    }

    return {
        top: top - zeroTop,
        left: left - zeroLeft,
    };
}

export default getFloatingWrapperPosition;
